<template>
  <!-- <modal @close-modal="actionPrivilege = false" :showModal="actionPrivilege" width="585" :arrowTitle="true"
    title="Action/Privileges"> -->
    <modal  @close-modal="emitClose" :showModal="actionPrivilege" width="585" :arrowTitle="true"
    title="Action/Privileges">
    

    <div class="d-flex flex-row justify-content-between my-3">
      <div class="custom-card" style="width: 247.5px">
        <h1>Role Name</h1>
        <b>{{ rolePrivileges.name }}
        </b>
      </div>
      <div class="border my-auto" style="height: 43.5px"></div>
      <div class="custom-card d-flex flex-row justify-content-between" style="width: 247.5px; height: 80px">
        <span>Assigned To<br />

          <i style="font-size: 12px">{{ getUser.length }} User(s)</i></span>
        <span class="my-auto  cursor-pointer " background="white"
          style="color: #114ff5; font-size: 12px; margin-right: 0px" text="" @click="handleViewAllClick">
          View All
        </span>
      </div>
    </div>
    <hr class="text-muted" style="border-top: dashed 1px" />
    <p class="my-3">Modules & Sub-Modules</p>


    <div class="my-3">
      <div>
        <el-collapse class="bg-transparent"  v-model="activeCollapse">

          <el-collapse-item  :name="i" v-for="(mod, i) in _rolePrivileges" :key="i">
            <template #title>
              <span style="font-size: 16px; font-weight: 700; color: #1F1514;">
                {{ mod.name }}
              </span>
            </template>
            <div class="relative w-full tabs-wrapper">


              <button v-if="currentPage > 0" :disabled="currentPage === 0"
                class="absolute left-0 top-2  transform -translate-y-1/2 z-10 px-3 py-2 "
                @click="currentPage > 0 && currentPage--">
                <span class="chevron">
                  &#8249;
                </span>
              </button>



              <div class="flex justify-between items-center w-full  tabs-content-wrapper">
                <div class="grid grid-cols-3  w-full">


                  <div
                    v-for="(submodule) in mod.submodules.slice(currentPage * tabsPerPage, currentPage * tabsPerPage + tabsPerPage)"
                    :key="submodule.id" class="text-center py-2 px-3  cursor-pointer border-b transition tabs-content"
                    :class="[
                      activeTab === submodule.name ? 'active-tab' : 'inactive-tab'
                    ]" @click="setActiveTab(submodule.name, submodule.privileges, submodule.slug)">
                    {{ submodule.name }}
                  </div>
                </div>
              </div>


              <button v-if="(currentPage + 1) * tabsPerPage < mod.submodules.length"
                class="absolute right-0 top-2 transform -translate-y-1/2 z-10 px-3 py-2"
                :disabled="(currentPage + 1) * tabsPerPage >= mod.submodules.length"
                @click="(currentPage + 1) * tabsPerPage < mod.submodules.length && currentPage++">

                <span class="chevron">
                  &#8250;
                </span>
              </button>

              <div class="mt-3" v-if="activePrivileges.length">
                <div class="">
                  <h2 class="font-bold">PRIVILEGES</h2>

                </div>

                <div class="priv-wrap">
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group id="privileges-check-box" v-model="privilegeManager"
                      :aria-describedby="ariaDescribedby">
                      <div class="grid grid-rows-5 grid-flow-col  privilege-grid">

                        <div v-for="(privilege) in activePrivileges" :key="privilege.id" class="privilege-item">

                          <b-form-checkbox :value="privilege.id" class="readonly-checkbox">{{ privilege.name
                            }}</b-form-checkbox>
                        </div>
                      </div>
                    </b-form-checkbox-group>
                  </b-form-group>
                </div>
              </div>

            </div>


          </el-collapse-item>
        </el-collapse>

      </div>
    </div>
    <div class="d-flex flex-row-reverse" style="margin-top: 200px">
      <!-- <button style="width: 157px; height: 48px" @click="actionPrivilege = false"
        class="border border-black rounded py-1 px-2 font-normal mr-4"> -->
        <button style="width: 157px; height: 48px"  @click="emitClose"
        class="border border-black rounded py-1 px-2 font-normal mr-4">
        Close
      </button>
    </div>

  </modal>

</template>

<script>
import Modal from "./Modal.vue";


export default {
  components: {
    Modal,
  },
  props: {

    rolePrivileges: {
      type: Object,

      default: () => ({}),
    },
    assignedUsers: {
      type: Array,
      default: () => [],
    },

    actionPrivilege: {
      type: Boolean,

    },
  },
  data() {
    return {
      selectedModule: "",
      selectedAppModules: [],
      currentTab: "",
      view: true,
      activeModuleId: null,
      subActiveModuleId: null,
      appModules: [],

      activeCollapse: null,

      tabsPerPage: 3,
      currentPage: 0,
      activeTab: '',
      activeSlug: '',
      activePrivileges: [],
      privilegeManager: [],

    };
  },


  methods: {
   emitClose() {
    this.$emit("close-action-modal");
  },
    async getModules() {
      try {
        this.loadingPrivileges = true;
        const response = await this.$_getModulesAndPrivileges();
        this.appModules = response.data.data;


      } catch (error) {
        throw new Error(error);
      } finally {
        this.loadingPrivileges = false;
      }
    },
    handleViewAllClick() {
      this.$emit('open-users-modal', true);
      this.$emit('close-action-modal', false);
    },


    setActiveTab(tab, privileges, slug) {
      this.activeTab = tab
      this.activePrivileges = privileges
      this.activeSlug = slug
      this.privilegeManager = privileges.map(p => p.id);
    }

  },
  computed: {
    selectedRoleObjects() {
      return this.appModules.filter(module =>
        this.selectedAppModules.includes(module.name)
      );
    },
    getUser() {
      return this.assignedUsers;
    },
    _rolePrivileges() {
      return this.rolePrivileges.modules;
    }
  },
};
</script>

<style scoped>
.readonly-checkbox {
  pointer-events: none;
  cursor: not-allowed;
}

.readonly-checkbox .custom-control-label {
  pointer-events: none;
  cursor: not-allowed;
}

.active-tab {
  font-weight: 600;
  background-color: #FFFFFF;
  border-bottom: 4px solid #F7B538;
}

.inactive-tab {
  border-bottom: 4px solid #F0F4FE;
  opacity: 0.5;
  /* faded text */
  transition: opacity 0.3s ease;
}

.inactive-tab:hover {
  opacity: 0.75;
  /* slightly more visible on hover */
}


.tabs-wrapper {
  margin-top: 3%;
}

button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.chevron {
  color: #F7B538;
  font-size: 24px;
  /* Adjust the size as needed */
}

.priv-wrap {

  margin-top: 5px;

}

.module_label {
  padding: 0.5em 1em;
  border: 1px solid rgb(171, 160, 160);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.custom-card>h1 {
  font-weight: 600;
  font-size: 14px;
  color: #1F1514;
}

.custom-card>b {
  font-weight: 500;
  font-size: 12px;
  color: #1F1514;
}
</style>
